import { Link } from "react-router-dom";

export function NotFoundRoute() {
  return (
    <section>
      <h1 style={{ marginTop: 0 }}>ページが見つかりません</h1>
      <p style={{ color: "var(--color-text-sub)" }}>
        指定されたページは存在しないか、移動した可能性があります。
      </p>
      <p>
        <Link to="/">ホームに戻る</Link>
      </p>
    </section>
  );
}
